// extracted by css-extract-rspack-plugin
export default {"GrayedBox":"jFNQ_"};